import React from 'react';
import { ReportView } from '../components/ReportView.jsx';

export function Reports({ data, onOpenClient, onOpenProject, onOpenUser }) {
  return (
    <ReportView
      data={data}
      mode="all"
      onOpenClient={onOpenClient}
      onOpenProject={onOpenProject}
      onOpenUser={onOpenUser}
    />
  );
}
